import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class CashTransferDetailService extends DatabaseGwService {
  URL_PATH:any="/cash-transfers-detail";

  
}
